import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "shards-react";
import { matchPath } from 'react-router'
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import api from '../components/common/api';
import axios from 'axios';
import { TextField } from "@material-ui/core";
import { withStyles } from '@material-ui/styles';
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import AttachFileIcon from '@material-ui/icons/AttachFile';

const styles = theme => ({
    formControl: {
        margin: 10,
        minWidth: 150,
        fontSize: '0.75rem',
    },
    typography: {
        color: 'rgba(0, 0, 0, 0.54)',
        padding: 0,
        fontSize: '1rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: 1,
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
        letterSpacing: '0.00938em',
        transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    }
});
  
class WorkOrderApproval extends Component{

    constructor(){
        super()
        this.state = {
            loading: true,
            message:'',
            work_order_approval:{
                id:'',
                reject_reason:'',
                approve:0
            }
        }

    }

    async componentDidMount(){
        const searchParams = new URLSearchParams(window.location.search);
        const match = matchPath(this.props.history.location.pathname, {
            path: '/work-order-approval/:id',
            exact: true,
            strict: false
        })
        const id = match.params.id
        await this.validateWorkOrderApproval(id)
    }

    validateWorkOrderApproval(id){
	    axios
            .get(api.work_order_approval().show(id),{ })
            .then(res => {
                var work_order_approval = res.data
                this.setState({work_order_approval: work_order_approval, loading: false})
                return res.data
            })
            .catch(err =>{
                this.setState({loading: false, message: "No existen una aprobación. Por favor contacte a su administrador."})
            })

    }

    handleChange = e => {
        var work_order_approval = this.state.work_order_approval
        work_order_approval[e.target.name] = e.target.value
        this.setState({work_order_approval: work_order_approval})
    }

    handleReject = () => {
        var work_order_approval = this.state.work_order_approval
        work_order_approval.rejected = 1 
        this.setState({work_order_approval: work_order_approval})
    }

    handleCancel = () => {
        var work_order_approval = this.state.work_order_approval
        work_order_approval.rejected = 1 
        work_order_approval.cancel = 1 
        this.setState({work_order_approval: work_order_approval})
    }

    handleDownloadBudget = (id) => {
        var url = api.media_download+'/' + id
        window.open(url, "_blank")		  		
    }

    handleSubmit = () => {
        var id = this.state.work_order_approval.id
        var url = api.work_order_approval().approve(id)
        var message = 'Gracias por aprobar esta orden de trabajo'
	    var formData = new FormData();
        if (this.state.work_order_approval.rejected === 1){
            url = api.work_order_approval().reject(id)
            var message = 'Hemos recibido correctamente su rechazo. Nos pondremos en contacto pronto!'
            formData.set("reject_reason", this.state.work_order_approval.reject_reason);
        }
        if (this.state.work_order_approval.cancel === 1){
            url = api.work_order_approval().cancel(id)
            var message = 'Hemos recibido correctamente su rechazo. Se cancela la orden de trabajo'

        }   
        var self = this
	    formData.set("id", this.state.work_order_approval.id);

	    axios.post(url,
            formData,
            {})
            .then(res => {
                self.setState({
                    message: message
                })
            })
            .catch(err =>{
              self.setState({
                  message: 'Ha ocurrido un error al cargar su respuesta. Disculpe las molestias ocasionadas.'
              })  
            })
    }
    render (){
		const { classes } = this.props;

        return (
        <Container fluid className="main-content-container px-4" style={{height: '100vh'}}>
            <Row noGutters className="h-100">
                <Col lg="10" md="10" className="mx-auto my-auto">
                    <Card>
                        <CardBody>
                        {/* Logo */}
                            <img
                            className="d-table mx-auto mb-3 text-center"
                            src={require("../images/logoautocorp.png")}
                            alt="Aprobar OT"
                            />


                        { (this.state.message !== '')

                        ?
                            <h5 className="text-center">{this.state.message}</h5>
                        :
                        
                            (this.state.loading)
                            ?
                                <React.Fragment>
                                    <CircularProgress color="inherit" /> <Typography className="ml-2" variant="h5" color="primary">Cargando ...</Typography>
                                </React.Fragment>
                            :
                                (this.state.work_order_approval.approve || (this.state.work_order_approval.rejected && this.state.work_order_approval.reject_date)  )
                                ?
                                        (this.state.work_order_approval.approve)
                                        ?
                                            <h5 className="text-center">La orden de trabajo ya fue aprobada! Muchas gracias!</h5>
                                        :
                                            <h5 className="text-center">La orden de trabajo ya fue rechazada! Pronto nos pondremos en contacto nuevamente!</h5>
                                        :
                                        <React.Fragment>
                                            <h5 className="text-center mb-4">
                                                Aprobar Orden de trabajo # {this.state.work_order_approval.work_order.id}
                                            </h5>
                                            <TextField
                                                id="type"
                                                name="type"
                                                label="Tipo de Orden de trabajo"
                                                fullWidth
                                                disabled
                                                type="text"
                                                value={this.state.work_order_approval.work_order.type}
                                                margin="normal"
                                                className="mr-2 mt-1"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                                            />
                                            <TextField
                                                id="plate"
                                                name="plate"
                                                label="Patente"
                                                fullWidth
                                                disabled
                                                type="text"
                                                value={this.state.work_order_approval.work_order.plate}
                                                margin="normal"
                                                className="mr-2 mt-1"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                                            />
                                            <TextField
                                                id="vehicle"
                                                name="vehicle"
                                                label="Modelo"
                                                fullWidth
                                                disabled
                                                type="text"
                                                value={this.state.work_order_approval.work_order.vehicle}
                                                margin="normal"
                                                className="mr-2 mt-1"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                                            />
                                            <TextField
                                                id="reason"
                                                name="reason"
                                                label="Motivo"
                                                fullWidth
                                                disabled
                                                type="text"
                                                value={this.state.work_order_approval.work_order.reason}
                                                margin="normal"
                                                className="mr-2 mt-1"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                                            />

                                            <TextField
                                                id="total_s_iva_price"
                                                name="total_s_iva_price"
                                                label="Monto total"
                                                fullWidth
                                                disabled
                                                type="text"
                                                value={"$" + this.state.work_order_approval.work_order.total_s_iva_price}
                                                margin="normal"
                                                className="mr-2 mt-1"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                                            />
                                            {(this.state.work_order_approval.rejected === 1)
                                            ?
                                                <TextField
                                                    id="reject_reason"
                                                    name="reject_reason"
                                                    label="Motivo de rechazo"
                                                    fullWidth
                                                    type="text"
                                                    required
                                                    placeholder="Ingrese el motivo de rechazo"
                                                    onChange={this.handleChange}
                                                    value={this.state.work_order_approval.reject_reason}
                                                    margin="normal"
                                                    className="mr-2 "
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                                                />
                                            :
                                                ''
                                            }
                                            <div className="mt-2">
                                                {(this.state.work_order_approval.rejected === 1)
                                                ?
                                                    <Button onClick={this.handleSubmit} variant="contained" color="secondary"  className="mr-2">
                                                        Confirmar rechazo
                                                    </Button>
                                                :
                                                    <React.Fragment>
                                                        {(this.state.work_order_approval.work_order.media_id)
                                                        ?
                                                            <Button onClick={(e) => {this.handleDownloadBudget(this.state.work_order_approval.work_order.media_id)} } variant="contained" color="primary" className="mr-2"  endIcon={<AttachFileIcon />}>
                                                                Descargar detalle
                                                            </Button>
                                                        :
                                                            ''
                                                        }
                                                        <Button onClick={this.handleSubmit} variant="contained" color="primary" className="mr-2">
                                                            Aprobar
                                                        </Button>
                                                        <Tooltip title={"Al solicitar recotización un Operador reverá la Orden de Trabajo según el motivo por usted indicado"} arrow>
                                                            <Button onClick={this.handleReject} variant="contained" color="secondary"  className="mr-2">
                                                                Solicitar recotización
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title={"Al rechazar se cancelará definitivamente la Orden de Trabajo solicitada"} arrow>
                                                            <Button onClick={this.handleCancel} variant="contained" color="secondary"  className="mr-2">
                                                                Rechazar
                                                            </Button>
                                                        </Tooltip>
                                                    </React.Fragment>
                                                }
                                            </div>

                                        </React.Fragment>
                        }
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        )
    } 
}

export default withStyles(styles)(WorkOrderApproval);
